import request from '@/utils/request'

// 服务费管理 分页 前台
export function pageByDTO(query) {
    return request({
        url: '/cashBonuslist/pageByDTO',
        method: 'get',
        params: query
    })
}

// 服务费管理 集合 前台
export function listByDTO(query) {
    return request({
        url: '/cashBonuslist/listByDTO',
        method: 'get',
        params: query
    })
}

// 服务费管理 查看 前台
export function viewById(query) {
    return request({
        url: '/cashBonuslist/viewById',
        method: 'get',
        params: query
    })
}

// 服务费管理 发票提交 前台
export function invoiceCommit(data) {
    return request({
        url: '/cashBonuslist/invoiceCommit',
        method: 'post',
        data
    })
}
